if (!customElements.get('image-slider')) {
  class VerticalSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (
        !this.querySelector('[data-slider]') ||
        this.hasAttribute('disabled')
      ) {
        return;
      }

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 31,
        direction: 'vertical',
        loop: true,
        freeMode: {
            enabled: true,
            momentum: false
        },
        speed: 6969,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: 0,
        disableOnInteraction: false,

        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  customElements.define('image-slider', VerticalSlider);
}
